export const Marquee = () => {
  const items = ["Canada — U.S. Expedited Freight", "Cargo Van & Sprinter Specialists", "Time-Critical Cross-Border Coordination", "Ground Expedite"];
  const loop = [...items, ...items];
  return (
    <div className="bg-oyf-black py-4 overflow-hidden border-y border-oyf-charcoal" data-testid="marquee">
      <div className="marquee-track">
        {loop.map((t, i) => (
          <div key={i} className="flex items-center whitespace-nowrap">
            <span className="text-oyf-yellow font-display font-extrabold text-xl md:text-2xl uppercase tracking-tight px-8">{t}</span>
            <span className="text-oyf-yellow text-xl">◆</span>
          </div>
        ))}
      </div>
    </div>
  );
};
